import { create } from "zustand";
import {
  getCustomerData,
  getFreshChatData,
  getRecentCommentData,
  getActivityLogData,
  getAvailableDoctorsData,
  getAssignedDoctorsData,
  getPrescriptionData,
  getEngagementsData,
  getFeedbackData,
  setShippingPending,
  setBulkOrderCount,
  getConsultFeedBack,
  getChatDuplicateList,
  setUserProfile,
  setConsultFeedback,
  setDirectOrder,
  getEngagementSlots,
  setReschedule,
  setNotAnswered,
  setRescheduleCall,
  getProductMapping,
  getCase,
  setMarkAsSingle,
  setSubscriptionOrder,
  makeCall,
  getDiscountCodes,
  addCartLink,
  postCartLink,
  makeCODOrder,
  validateAddressCharacters,
  sendCODOrderOTP,
  verifyCODOrderOTP,
  postComment,
  getConsultCallBookings,
  getOrders,
  removeComment,
  getTicketHistory,
  getUploadDocuments,
  downloadInternationalPrescriptions,
  getAllTag,
  putRescheduleWithComment,
  orderCancellation,
  getValidWarehouse,
  checkValidWarehouse,
  postWarehouse,
  postMarkShipped,
  postMarkDelivered,
  putVoidOrder,
  postRTOVoidOrder,
  getOrderTRackingInfo,
  markSlotFinished,
  markOrderInProgress,
  getMedicines,
  getDosages,
  postPrescription,
  deletePrescription,
  onBoardingApi,
  getDoctorSlotApi,
  postDoctorSlot,
  allDoctor,
  assignDoctorToOrder,
  removeAssignedDoctor,
  autoAssign,
  assignLeadOrder,
  getExpectation,
  slotApi,
  getSlotApi,
  putPrescription,
  rootCause,
  monthKit,
  getMedicalSlotApi,
  getPrescriptionInfo,
  getDiscountCodeVal,
  getRtoReattemptCategoryData,
  cancelFullfillment,
  deleteScalp,
  markPaidSlotFinished,
  getEngagementResponseData,
  getOldEngagementResponseData,
  imageTag,
  getFeedbackFormData,
  bookApptSlot,
  discountCode,
  caseMoengageEvents,
  booNearestSlot,
  getCaseFormResponses,
  getOfflineCustomerInfo,
  getOfflineCoachAppointment,
  getOfflineDoctorAppointment,
  fetchStateCityFromPincode,
  getAiSummary,
  getAvailableInterventionDoctorsData,
  getNearestClinics,
  getClinicDoctorSlots,
  setActivityLogData,
  getSetting,
  getSlotApiForPC,
  getRefundDetails,
  initiateRefund,
  getNpsCaseData,
  getRateLimitStatus,
  removeRateLimitApi,
} from "../api/index";
import { transformOrderForAddressValidation } from "../utils";

import { Spinner } from "react-bootstrap";
import { assignedOrderFilterData } from "modules/customerlist/api";
import { getNearestSlot, getReps } from "modules/case_management/api/api";
import moment from "moment-timezone";
import api from "../../../../api";
import { TOAST_MESSAGE_CSS, getJsonFromSecureLocalStorage, markBlockedClinicSlots } from "modules/utilities/utility";
import _ from "lodash";
import { toast } from "react-toastify";
import { persist } from "zustand/middleware";
import { safePersistStorage } from "helpers/safePersistStorage";
import { isEmpty } from "lodash";
import secureLocalStorage from "react-secure-storage";
// import { NORMAL_ORDER_DATA, SUBSCRIPTION_DATA } from "../api/DATA";
import { getSubscriptionRefundDetails as getSubscriptionRefundDetailsAPI, initiateOfflineRefund } from "modules/refund_management/api";

const initialState = {
  customerData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
};
export const useCustomer = create((set) => ({
  ...initialState,
  fetchCustomerData: async (case_id, signal) => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true, customerData: {} });
    try {
      const response = await getCustomerData(case_id, signal);
      set({ customerData: response.data, isLoading: false });
    } catch (error) {
      // Don't set error state if request was aborted
      if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
        return;
      }
      set({
        errorMessage:
          error?.response?.data?.Error ||
          "API is failing due to timeout or You do not have access to access this caseId",
        isError: true,
        isLoading: false,
      });
    }
  },
  customeStateClear: () => {
    set(initialState);
  },
}));

export const useProductMapping = create(
  persist(
    (set, get) => ({
      productsData: [],
      isLoading: false,
      isError: false,
      errorMessage: "",

      fetchProducts: async () => {
        const state = get();
        if (!isEmpty(state.productsData)) {
          return;
        }
        set({ isLoading: true, isError: false, errorMessage: "" });
        try {
          const response = await getProductMapping();
          set({ productsData: response.data, isLoading: false });
        } catch (error) {
          const errorMsg = error?.response?.data?.message || "Failed to fetch products.";
          set({ isError: true, isLoading: false, errorMessage: errorMsg });
          console.error("Error fetching product data:", errorMsg);
        }
      },

      getStateCityFromPincode: async (pincode) => {
        try {
          const response = await fetchStateCityFromPincode(pincode);
          return response.data;
        } catch (error) {
          console.log('Error while fetching data: ', error);
        }
  },
    }),
    {
      name: "product-mapping-storage",
      storage: safePersistStorage,
      partialize: (state) => ({ productsData: state.productsData }), // Persist only productsData
    }
  )
);

export const useDiscountCodes = create((set) => ({
  discountCodes: {},
  isLoading: false,
  isError: false,
  fetchDiscountCodes: async () => {
    set({ isLoading: true });
    try {
      const response = await getDiscountCodes();
      set({ discountCodes: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useFreshChatData = create((set) => ({
  data: {},
  isLoading: false,
  isError: false,
  fetchFreshChatData: async (customer_id) => {
    set({ isLoading: true });
    try {
      const response = await getFreshChatData(customer_id);
      set({ data: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useRecentComment = create((set, get) => ({
  data: {},
  isLoading: false,
  isError: false,
  lastFetchedCustomerId: null,
  fetchRecentCommentData: async (customer_id) => {
    const state = get();

    // Prevent duplicate API calls for the same customer_id
    if (state.isLoading && state.lastFetchedCustomerId === customer_id) {
      return;
    }

    set({ isLoading: true, lastFetchedCustomerId: customer_id });
    try {
      const response = await getRecentCommentData(customer_id);
      set({ data: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useEngagementResponse = create((set) => ({
  data: {},
  isLoading: false,
  isError: false,
  fetchEngagementResponse: async (customer_id) => {
    set({ isLoading: true });
    try {
      const response = await getEngagementResponseData(customer_id);
      set({ data: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useActivityLog = create((set, get) => ({
  data: {},
  activityLogData: [],
  pageCount: 1,
  isLoading: false,
  isError: false,
  fetchActivityLogData: async (customer_id, pageNumber) => {
    set({ isLoading: true });
    try {
      const response = await getActivityLogData(customer_id, pageNumber);
      set((state) => ({
        data: response.data,
        isLoading: false,
        pageCount: response.data.pagination.pageCount,
        activityLogData: [...state.activityLogData, ...response.data.data], // Append new data
      }));
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  clearActivityData: () => {
    set({ activityLogData: [] });
  },

  setActivityLogData: async (caseId, eventId, meta = {}) => {
    try {
      const response = await setActivityLogData(caseId, eventId, meta);
      return response; // Return response for caller to handle success
    } catch (error) {
      // Multi-level error extraction following codebase pattern
      const fallbackError = _.get(error, ['message'], 'Failed to log activity');
      const errorMessage = _.get(error, ['response', 'data', 'message'], fallbackError);
      const nestedError = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);
      throw new Error(nestedError); // Throw for caller to handle
    }
  }
}));

export const useDoctors = create((set, get) => ({
  availableDoctorsData: {},
  availableInterventionDoctorsData: [],
  assignedDoctorsData: {},
  isLoading: false,
  isError: false,

  fetchAvailableInterventionDoctorsData: async () => {
    try {
      const response = await getAvailableInterventionDoctorsData();
      set({ availableInterventionDoctorsData: response.data });
    } catch (error) {
      set({ isError: true });
    }
  },
  fetchAvailableDoctorsData: async () => {
    try {
      const response = await getAvailableDoctorsData();
      set({ availableDoctorsData: response.data });
    } catch (error) {
      set({ isError: true });
    }
  },
  fetchAssignedDoctorsData: async (customer_id) => {
    try {
      const response = await getAssignedDoctorsData(customer_id);
      set({ assignedDoctorsData: response.data });
    } catch (error) {
      set({ isError: true });
    }
  },
  unassignDoctor: async (customerId, payload, toast) => {
    const { fetchAvailableDoctorsData, fetchAssignedDoctorsData } = get();
    try {
      set({ isLoading: true });
      await removeAssignedDoctor(payload);
      fetchAvailableDoctorsData();
      fetchAssignedDoctorsData(customerId);
      toast.success("Unassigned Successfully", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to Unassign", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      set({ isLoading: false });
    }
  },
  assignDoctor: async (customerId, payload, toast) => {
    const { fetchAvailableDoctorsData, fetchAssignedDoctorsData } = get();
    try {
      set({ isLoading: true });
      await assignDoctorToOrder(payload);
      fetchAssignedDoctorsData(customerId);
      fetchAvailableDoctorsData();
      toast.success("Assigned Successfully", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to assign", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      set({ isLoading: false });
    }
  },
  autoAssignDoctor: async (orderId, toast) => {
    const { fetchAvailableDoctorsData, fetchAssignedDoctorsData } = get();
    try {
      toast.warn("Auto Assigning please wait", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      await autoAssign({ order_id: orderId });
      fetchAssignedDoctorsData(orderId);
      fetchAvailableDoctorsData();
      toast.success("Auto Assigned Successfully", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to auto assign", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  },
}));

export const usePrescription = create((set) => ({
  prescriptionsData: [],
  isLoading: false,
  isError: false,
  fetchPrescriptionData: async (customer_id) => {
    set({ isLoading: true });
    try {
      const response = await getPrescriptionData(customer_id);
      set({ prescriptionsData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useEngagements = create((set) => ({
  engagementsData: {},
  isLoading: false,
  isError: false,
  fetchEngagementsData: async (order_id) => {
    set({ isLoading: true });
    try {
      const response = await getEngagementsData(order_id);
      set({ engagementsData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useFeedback = create((set) => ({
  feedbackData: {},
  isLoading: false,
  isError: false,
  fetchFeedbackData: async (order_id) => {
    set({ isLoading: true });
    try {
      const response = await getFeedbackData(order_id);
      set({ feedbackData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useSendToDispatch = create((set) => ({
  sendToDispatchResponseStatus: "",
  isLoading: false,
  isError: false,
  setSendToDispatch: async (order_id, setToaster) => {
    set({ isLoading: true });
    try {
      const response = await setShippingPending(order_id);
      set({ sendToDispatchResponseStatus: response.status, isLoading: false });
      setToaster("Dispatch", "Order is sent to dispatch", "success");
    } catch (error) {
      set({ isError: true, isLoading: false });
      setToaster("Dispatch", "Failed to send order in dispatch", "danger");
    }
  },
}));

export const useBulkOrder = create((set) => ({
  sendBulkOrderStatus: "",
  isLoading: false,
  isError: false,
  setBulkOrderRequest: async (duration, order_id, setToaster) => {
    set({ isLoading: true });
    try {
      const response = await setBulkOrderCount(duration, order_id);
      set({ sendBulkOrderStatus: response.status, isLoading: false });
      setToaster("Bulk Order", "Order MArked as Bulk", "success");
    } catch (error) {
      set({ isError: true, isLoading: false });
      setToaster("Bulk Order", "Failed to mark order as bulk", "danger");
    }
  },
}));

export const useConsultFeedback = create((set) => ({
  consultFeedbackData: {},
  prescriptionData: {},
  isLoading: false,
  isError: false,
  caseFormResponses: [],
  fetchCaseResponses: async (caseId) => {
    try {
      const response = await getCaseFormResponses(caseId);
      set({ caseFormResponses: response.data });
    } catch (error) {
      set({ caseFormResponses: [] });
    }
  },
  fetchFeedbackData: async (case_id, setCustomConsultFeedbackForm) => {
    setCustomConsultFeedbackForm && setCustomConsultFeedbackForm({});
    set({ isLoading: true });
    try {
      const response = await getConsultFeedBack(case_id);
      set({ consultFeedbackData: response.data, isLoading: false });
      if (response.data.feedback) {
        setCustomConsultFeedbackForm &&
          setCustomConsultFeedbackForm(response.data.feedback);
      }
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  fetchPrescriptionData: async (case_id) => {
    set({ isLoading: true, isError: true });
    try {
      const response = await getPrescriptionInfo(case_id);
      set({ prescriptionData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false, prescriptionData:{}});
    }
  },
}));

export const useCaseDetails = create((set) => ({
  caseDetails: {},
  caseDetailsLoading: false,
  isError: false,
  fetchCaseDetails: async (case_id) => {
    set({ caseDetails: {} });
    set({ caseDetailsLoading: true });
    try {
      const response = await getCase(case_id);
      set({ caseDetails: response.data, caseDetailsLoading: false });
    } catch (error) {
      set({ isError: true, caseDetailsLoading: false });
    }
  },
}));

export const useChatDuplicateList = create((set) => ({
  chatDuplicateListData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchChatDuplicateList: async (phoneNumber) => {
    set({ isLoading: true });
    try {
      const response = await getChatDuplicateList(phoneNumber);
      set({ chatDuplicateListData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useSetUserProfile = create((set) => ({
  responseData: {},
  isLoading: false,
  isError: false,
  setUserProfileEdits: async (
    changedDetails,
    setToaster,
    fetchCustomerData,
    customer
  ) => {
    set({ isLoading: true });
    setToaster("Profile Update", "Updating Profile", "success");
    try {
      const response = await setUserProfile(customer.user_id, changedDetails);
      set({ responseData: response.data, isLoading: false });
      setToaster("Profile Update", "Profile updated successfully", "success");
      fetchCustomerData(customer.id);
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
      setToaster("Profile Update", "Failed to update profile", "danger");
    }
  },
}));

export const useSetConsultFeedback = create((set) => ({
  responseData: {},
  isLoading: false,
  isError: false,
  setConsultFeedback: async (
    id,
    changedDetails,
    setToaster,
    fetchFeedbackData,
    handleClose
  ) => {
    setToaster("Feedback", "Sending Feedback", "success");
    set({ isLoading: true });
    try {
      const response = await setConsultFeedback(id, changedDetails);
      set({ responseData: response.data, isLoading: false });
      handleClose();
      setToaster("Feedback", "Feedback sent", "success");
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
      setToaster("Feedback", "Failed to send feedback", "danger");
    } finally {
      set({
        isLoading: false,
      });
      handleClose();
      fetchFeedbackData(id);
    }
  },
}));

export const useSetDirectOrder = create((set) => ({
  responseData: {},
  isLoading: false,
  isError: false,
  setDirectOrder: async (id) => {
    set({ isLoading: true });
    try {
      const response = await setDirectOrder(id);
      set({ responseData: response.data, isLoading: false });
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
    }
  },
}));

export const useEngagementsSlots = create((set) => ({
  engagementSlotsData: [],
  isLoading: false,
  isError: false,
  fetchEngagementSlots: async (date) => {
    set({ isLoading: true });
    try {
      const response = await getEngagementSlots(date);
      set({ engagementSlotsData: response.data, isLoading: false });
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
    }
  },
}));

export const useReschedule = create((set) => ({
  rescheduleData: [],
  isLoading: false,
  isError: false,
  putSetReschedule: async (id, setToaster, dateTime, navigate, { isNextCall } = {}) => {
    setToaster("Reschedule", `Rescheduling call for ${dateTime}`, "success");
    set({ isLoading: true });
    try {
      const response = await setReschedule(id, moment(dateTime).format());
      set({ rescheduleData: response.data, isLoading: false });
      setToaster(
        "Reschedule",
        `Call is rescheduled for ${dateTime}`,
        "success"
      );
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
      setToaster(
        "Reschedule",
        `Failed to reschedule call for ${dateTime}`,
        "danger"
      );
    } finally {
      if (isNextCall) {
        setTimeout(() => {
          navigate("/next-call");
        }, 3000);
      }
    }
  },
}));

export const useRescheduleWithComment = create(() => ({
  rescheduleWithComment: async (
    id,
    reminder_date,
    comment,
    setToaster,
    navigate,
    { isNextCall } = {}
  ) => {
    setToaster(
      "Reschedule",
      `Rescheduling for ${reminder_date}, ${comment}`,
      "success"
    );
    try {
      await putRescheduleWithComment(id, {
        reminder_date,
        comment,
      });
      setToaster(
        "Reschedule",
        `Rescheduled for ${reminder_date}, ${comment}`,
        "success"
      );
    } catch (error) {
      setToaster(
        "Reschedule",
        `Failed to reschedule for ${reminder_date}, ${comment}`,
        "danger"
      );
    } finally {
      if (isNextCall) {
        setTimeout(() => {
          navigate("/next-call");
        }, 5000);
      }
    }
  },
}));
export const useNotAnswered = create((set) => ({
  notAnsweredResponse: {},
  isLoading: false,
  isError: false,
  postNotAnswered: async (id, setToaster) => {
    setToaster("Unanswered call", "Marking as Unanswered call", "warning");
    set({ isLoading: true });
    try {
      const response = await setNotAnswered(id);
      set({ notAnsweredResponse: response.data, isLoading: false });
      setToaster("Unanswered call", "Call marked as Unanswered", "success");
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
      set("Unanswered call", "failed to mark call as unanswered");
    }
  },
}));

export const useRescheduleCall = create((set) => ({
  rescheduleCallData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  rescheduleCall: async (id, setToaster) => {
    setToaster("Reschedule Call", "Rescheduling call", "warning");

    set({ isLoading: true });
    try {
      const response = await setRescheduleCall(id);
      set({ notAnsweredResponse: response.data, isLoading: false });
      setToaster("Reschedule Call", "Call is reschedule", "success");
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
      setToaster("Reschedule Call", error?.response.data.message, "danger");
    }
  },
}));

export const useMarkAsSingle = create((set) => ({
  responseMarkAsSingle: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  markAsSingle: async (id, is_single_order, setToaster) => {
    set({ isLoading: true });
    try {
      const response = await setMarkAsSingle(id, is_single_order);
      setToaster(
        "Mark Order as single",
        `Order ${is_single_order ? "marked " : "unmarked"} as single Order`,
        is_single_order ? "success" : "danger"
      );
      set({ responseMarkAsSingle: response?.data, isLoading: false });
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
    }
  },
}));

export const useSubscriptionOrder = create((set) => ({
  responseSubscriptionOrder: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  subscriptionOrder: async (order_id, status, setToaster) => {
    setToaster(
      "MarkIng Order as Subscription",
      `Order ${
        status === "true" ? "marking" : "un-marking"
      } as subscription order`,
      "warning"
    );
    set({ isLoading: true });
    try {
      const response = await setSubscriptionOrder(order_id, status);
      setToaster(
        "Mark Order as Subscription",
        `Order ${
          status === "true" ? "marked" : "unmarked"
        } as subscription order`,
        status === "true" ? "success" : "danger"
      );
      set({ responseSubscriptionOrder: response.data, isLoading: false });
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response
          ? error?.response.data.message
          : "An error occurred",
      });
      setToaster(
        "Mark Order as Subscription",
        error?.response ? error?.response.data.message : "An error occurred",
        "danger"
      );
    }
  },
}));

export const useCall = create((set) => ({
  responseCall: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  call: async (case_id, note, engagement_id, phone_number, setToaster, eng, provider_name) => {
    set({ isLoading: true });
    setToaster(
      <div className="d-flex align-items-center">
        <Spinner size="sm" /> Calling
      </div>,
      `Preparing call in progress`,
      "warning"
    );
    try {
      const response = await makeCall(
        case_id,
        note,
        engagement_id,
        phone_number,
        eng,
        provider_name
      );
      const responseData = await response?.data
      // Store attemptId mapped to engagementId for mark-done
      const engId = responseData?.engagement?._id;
      if (engId && responseData?.attemptId) {
        const attemptMap = getJsonFromSecureLocalStorage('attemptMap') || {};
        attemptMap[engId] = responseData.attemptId;
        secureLocalStorage.setItem('attemptMap', JSON.stringify(attemptMap));
      }
      set({ responseCall: responseData, isLoading: false });
      setToaster("Call", `Call is in progress`, "success");
      return responseData
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response?.data.message,
      });
      setToaster("Call", error?.response?.data?.message|| "Call failed", "danger");
    }
  },
}));

export const useGenerateCartLink = create((set, get) => ({
  sendCartLinkResponse: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  productCanvas: false,
  bookingId: "",
  setProductCanvas: (toggle) => {
    set({ productCanvas: toggle });
  },
  setBookingId: (id) => {
    set({ bookingId: id });
  },
  generateCartLink: async (
    case_id,
    orderLink,
    cartValue,
    setToaster,
    setShowCopy
  ) => {
    set({ isLoading: true });
    const { sendCartLink } = get();
    try {
      const response = await addCartLink(case_id, orderLink);
      set({ sendCartLinkResponse: response.data, isLoading: false });
      sendCartLink(case_id, orderLink, cartValue, setToaster, setShowCopy);
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response?.data?.message,
      });
    }
  },
  sendCartLink: async (id, cart_link, cart_value, setToaster, setShowCopy) => {
    setToaster(
      <div className="d-flex align-items-center">
        <Spinner size="sm" /> Generating Link
      </div>,
      "ORder Link is generating",
      "warning"
    );
    const { productCanvas } = get();
    set({ isLoading: true });
    try {
      await postCartLink(id, cart_link, cart_value, productCanvas);
      setToaster(
        "Link Generated",
        "Order link is generated, please proceed to placing order",
        "success"
      );
      setShowCopy(true);
    } catch (error) {
      console.error(error);
      set({
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useCODOrder = create((set) => ({
  codOrderResponse: {},
  isLoading: false,
  isError: false,
  isBadAddressError: false,
  errorMessage: "",
  isAddressValidationError: false,
  addressValidationDetails: null,

  resetAddressValidationError: () => {
    set({
      isAddressValidationError: false,
      addressValidationDetails: null,
      isError: false,
      isBadAddressError: false,
      errorMessage: ''
    });
  },

  createCODOrder: async (order, setToaster, handleClose, setChangeFlag, setZipInValidateFlag) => {
    setToaster("COD Order", "Placing order", "success");
    set({ isLoading: true });
    const checkIsAvailable = [
      "last_name",
      "phone",
      "address1",
      "address2",
      "country",
      "city",
      "province",
      "zip",
    ];

    const requiredKeys = [
      "email",
      "phone",
      "billing_address",
      "shipping_address",
    ];

    const shippingAddress = Object.entries(order.order.shipping_address).filter(
      ([field, value]) =>
        checkIsAvailable.includes(field) &&
        value !== "undefined" &&
        value !== "null" &&
        value && value.toString().trim().length
    );

    const billingAddress = Object.entries(order.order.billing_address).filter(
      ([field, value]) =>
        checkIsAvailable.includes(field) &&
        value !== "undefined" &&
        value !== "null" &&
        value &&  value.toString().trim().length
    );

    const presentValues = requiredKeys?.map((key) => order?.order[key]);

    try {
      if (
        shippingAddress.length === 8 &&
        billingAddress.length === 8 &&
        presentValues?.length === 4
      ) {
        // STEP 1: Validate address quality first
        try {
          const validationPayload = transformOrderForAddressValidation(order);
          const validationResponse = await validateAddressCharacters(validationPayload);

          // STEP 2: Check validation response
          if (validationResponse.data.success && validationResponse.data.validation.hasIssues) {
            // Address has quality issues - block order and show errors
            set({
              isLoading: false,
              isError: true,
              isAddressValidationError: true,
              addressValidationDetails: validationResponse.data.validation.details,
              errorMessage: 'Address validation failed. Please fix the issues below:'
            });
            setToaster("COD order", "Address validation failed", "danger");
            return; // Stop order placement
          }
        } catch (validationError) {
          // STEP 3: Handle validation API errors gracefully
          if (validationError?.response?.status === 404 || validationError?.message?.includes('validate-address-characters')) {
            // If validation endpoint doesn't exist, proceed with order anyway
            console.warn("Address validation endpoint not available, proceeding with order");
          } else if (validationError?.code === 'ECONNABORTED' || validationError?.message?.includes('timeout')) {
            // If validation times out, proceed with order anyway
            console.warn("Address validation timeout, proceeding with order");
          } else {
            // For other unexpected errors, still proceed but log them
            console.warn("Address validation error:", validationError);
          }
        }

        // STEP 4: If validation passes or is skipped, proceed with order
        const response = await makeCODOrder(order);
        set({
          codOrderResponse: response.data,
          isError: false,
          isBadAddressError: false,
          isAddressValidationError: false,
          addressValidationDetails: null,
          errorMessage: '',
        });
        setToaster("COD order ", "Order is placed", "success");
        handleClose();
        setChangeFlag((prev) => !prev);
      } else {
        throw new Error("Incomplete address");
      }
    } catch (error) {
      if (error?.response) {
        if (error?.response?.data?.message === 'Bad Quality Address') {
          set({
            isError: true,
            isBadAddressError: true,
            isAddressValidationError: false,
            errorMessage: 'The address is not detailed. Ensure that below details are present to maximum extent possible and try again:',
          });
        } else {
          set({
            isError: true,
            isAddressValidationError: false,
            errorMessage: error?.response?.data?.message,
          });
        };
        setToaster("COD order", error?.response?.data?.message, "danger");
      } else {
        setToaster(
          "COD order",
          "Please contact tech team for this issue",
          "danger"
        );
      }
      console.warn(error, order.order.shipping_address);
    } finally {
      set({ isLoading: false });
      setZipInValidateFlag((prev) => !prev);
    }
  },
}));

export const useOTPVerification = create((set) => ({
  otpSent: false,
  otpMethod: null, // 'SMS' or 'WABA' or 'EMAIL'
  phoneNumber: null, // Masked phone number from backend
  isLoading: false,
  isError: false,
  errorMessage: "",

  sendOTP: async (caseId, method, orderAmount, address, setToaster) => {
    set({ isLoading: true, isError: false, errorMessage: "" });
    try {
      const response = await sendCODOrderOTP(caseId, method, orderAmount, address || '');
      const { success, message, expiresIn, isResend, phoneNumber } = response.data;

      if (success) {
        set({
          otpSent: true,
          otpMethod: method,
          phoneNumber: phoneNumber || null,
          isLoading: false,
          isError: false,
          errorMessage: ""
        });
        // Use both toast methods for compatibility
        const methodName = method === 'SMS' ? 'SMS' : method === 'WABA' ? 'WhatsApp' : 'Email';
        toast.success(message || `OTP sent successfully via ${methodName}`);
        setToaster(
          isResend ? "OTP Resent" : "OTP Sent",
          message || `OTP sent successfully via ${methodName}`,
          "success"
        );
      } else {
        // Handle case where success is false
        set({
          isError: true,
          errorMessage: message || "Failed to send OTP",
          isLoading: false
        });
      }
    } catch (error) {
      // Handle rate limiting (429) and other errors
      const status = error.response?.status;
      const responseData = error.response?.data;

      // Extract error message from different possible response structures
      let errorMsg = "Failed to send OTP";
      if (responseData?.message) {
        errorMsg = responseData.message;
      } else if (responseData?.error) {
        errorMsg = responseData.error;
      } else if (typeof responseData === 'string') {
        errorMsg = responseData;
      } else if (error.message) {
        errorMsg = error.message;
      }

      set({
        isError: true,
        errorMessage: errorMsg,
        isLoading: false,
        otpSent: false // Reset otpSent on error so user can try again
      });

      console.error("Send OTP Error:", error);
    }
  },

  verifyOTP: async (caseId, otp, onSuccess, onFailure, setToaster) => {
    set({ isLoading: true, isError: false, errorMessage: "" });
    try {
      const response = await verifyCODOrderOTP(caseId, otp);
      const { success, verified, message } = response.data;

      if (success && verified) {
        set({
          isLoading: false,
          isError: false,
          errorMessage: ""
        });
        onSuccess(); // Proceed with order placement
      } else {
        // Failed verification - show attempts remaining or other messages
        set({
          isError: true,
          errorMessage: message || "Invalid OTP",
          isLoading: false
        });

        // Show warning for attempts remaining, error for max exceeded or expired
        const isMaxExceeded = message?.includes("Maximum verification attempts exceeded");
        const isExpired = message?.includes("expired");

        if (isMaxExceeded || isExpired) {
          toast.error(message);
          setToaster("Error", message, "danger");
        } else {
          toast.warning(message);
          setToaster("Invalid OTP", message, "warning");
        }

        // Reset OTP input on failure
        if (onFailure) onFailure();
      }
    } catch (error) {
      const responseData = error.response?.data;

      // Extract error message from different possible response structures
      let errorMsg = "Invalid OTP";
      if (responseData?.message) {
        errorMsg = responseData.message;
      } else if (responseData?.error) {
        errorMsg = responseData.error;
      } else if (typeof responseData === 'string') {
        errorMsg = responseData;
      } else if (error.message) {
        errorMsg = error.message;
      }

      set({
        isError: true,
        errorMessage: errorMsg,
        isLoading: false
      });

      console.error("Verify OTP Error:", error);

      // Reset OTP input on error
      if (onFailure) onFailure();
    }
  },

  resetOTP: () => {
    set({
      otpSent: false,
      otpMethod: null,
      phoneNumber: null,
      isLoading: false,
      isError: false,
      errorMessage: ""
    });
  }
}));

export const useSendComments = create((set) => ({
  commentResponse: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  sendComment: async (id, comment, setToaster) => {
    setToaster(
      <div className="d-flex align-items-center">
        <Spinner size="sm" /> Sending Comment
      </div>,
      `Comment : "${comment}"`,
      "warning"
    );
    set({ isLoading: true });
    try {
      const response = await postComment(id, comment);
      set({ commentResponse: response.data, isLoading: false });
      setToaster("Comment Sent", comment, "success");
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
      setToaster("Comment Failed", "Failed to send the comment ", "danger");
    }
  },
}));

export const useConsultCall = create((set) => ({
  consultCallData: {},
  consultLoading: false,
  isError: false,
  errorMessage: "",
  fetchConsultCallData: async (page) => {
    set({ consultLoading: true });
    try {
      const response = await getConsultCallBookings(page);
      set({ consultCallData: response?.data, consultLoading: false });
    } catch (error) {
      if (error?.response) {
        set({
          isError: true,
          consultLoading: false,
          errorMessage: error?.response.data.message,
        });
      } else {
        set({
          isError: true,
          consultLoading: false,
          errorMessage: "An error occurred.",
        });
      }
    }
  },
}));

export const useNewOrders = create((set) => ({
  newOrdersData: {},
  newLoading: false,
  isError: false,
  errorMessage: "",
  fetchNewOrders: async (page, flag, filter) => {
    set({ newLoading: true });
    try {
      const response = await getOrders(page, flag, filter);
      set({ newOrdersData: response.data, newLoading: false });
    } catch (error) {
      if (error?.response) {
        set({
          isError: true,
          newLoading: false,
          errorMessage: error?.response.data.message,
        });
      } else {
        set({
          isError: true,
          newLoading: false,
          errorMessage: "An error occurred.",
        });
      }
    }
  },
}));

export const useRepeatOrders = create((set) => ({
  repeatOrdersData: {},
  repeatLoading: false,
  isError: false,
  errorMessage: "",
  fetchRepeatOrders: async (page, flag, filter) => {
    set({ repeatLoading: true });
    try {
      const response = await getOrders(page, flag, filter);
      set({ repeatOrdersData: response.data, repeatLoading: false });
    } catch (error) {
      if (error?.response) {
        set({
          isError: true,
          repeatLoading: false,
          errorMessage: error?.response.data.message,
        });
      } else {
        set({
          isError: true,
          repeatLoading: false,
          errorMessage: "An error occurred.",
        });
      }
    }
  },
}));

export const useDeleteComment = create(() => ({
  deleteComment: async (id, setToaster) => {
    setToaster("Comment", "Deleting comment", "success");
    try {
      await removeComment(id);
      setToaster("Comment", "Comment deleted", "success");
    } catch (error) {
      setToaster("Comment", "Failed to delete comment", "danger");
    }
  },
}));

export const useTicketHistory = create((set) => ({
  ticketData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  nearestSlot: "",
  fetchTicketHistory: async (id) => {
    set({ isLoading: true });
    try {
      const response = await getTicketHistory(id);
      set({ ticketData: response.data, isLoading: false });
    } catch (error) {
      if (error?.response) {
        set({
          isError: true,
          isLoading: false,
          errorMessage: error?.response.data.message,
        });
      } else {
        set({
          isError: true,
          isLoading: false,
          errorMessage: "An error occurred.",
        });
      }
    }
  },
}));

export const useOrderFilterData = create((set) => ({
  doctorData: [],
  consultData: [],
  medicalData: [],
  isLoading: false,
  isError: false,
  fetchDoctorData: async () => {
    set({ isLoading: true });
    try {
      const response = await getReps("consult_doctor");
      set({ doctorData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  fetchConsultRepData: async () => {
    set({ isLoading: true });
    try {
      const response = await getReps("consult_rep");
      set({ consultData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  fetchMedicalRepData: async () => {
    set({ isLoading: true });
    try {
      const response = await getReps("medical_rep");
      set({ medicalData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  fetchAssignedOrderFilterData: async (queryParams) => {
    set({ isLoading: true });
    try {
      const response = await assignedOrderFilterData(queryParams);
      set({ medicalData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useUploadDocuments = create((set) => ({
  uploadDocumentsData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchUploadDocuments: async (id) => {
    set({ isLoading: true });
    try {
      const response = await getUploadDocuments(id);
      set({ uploadDocumentsData: response.data, isLoading: false });
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
    }
  },
}));

export const useDownloadInternationalPrescription = create((set) => ({
  prescriptionData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  downloadInternationalPrescription: async (
    customer_id,
    order_id,
    setToaster,
    setIsPrint
  ) => {
    set({ isLoading: true });
    try {
      const response = await downloadInternationalPrescriptions(
        customer_id,
        order_id
      );
      set({ prescriptionData: response.data });
      setIsPrint(true);
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
      setToaster(
        "Prescription Download",
        error?.response.data.message,
        "danger"
      );
    }
  },
}));


export const useGetAllTag = create(
  persist(
    (set, get) => ({
      allTag: [],
      tagLoading: false,
      isError: false,
      fetchTagData: async () => {
        const state = get();
        if (isEmpty(state.allTag)) {
          try {
            set({ tagLoading: true, isError: false });
            const response = await getAllTag();
            set({ allTag: response.data, tagLoading: false });
          } catch (error) {
            set({ isError: true, tagLoading: false });
            console.error("Failed to fetch tags:", error);
          }
        }
      },
    }),
    {
      name: "all-tag-storage",
      storage: safePersistStorage,
      partialize: (state) => ({ allTag: state.allTag }),
    }
  )
);

export const useOrderCancellation = create((set) => ({
  cancelOrderData: [],
  isLoading: false,
  isError: false,
  fetchOrderCancellation: async (payload, toast) => {
    set({ isLoading: true });
    try {
      const response = await orderCancellation(payload);
      set({ cancelOrderData: response.data, isLoading: false });
      toast.success(`Automatic Order Cancellation Ticket Raise successfully`);
    } catch (error) {
      toast.error(error?.response?.data?.message || `Order Cancellation Failed`);
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useRefundModal = create((set) => ({
  refundData: null,
  isLoading: false,
  isError: false,
  errorMessage: "",
  isInitiating: false,

  // Fetch refund details
  fetchRefundDetails: async (orderId, toast) => {
    set({ isLoading: true, isError: false, errorMessage: "" });
    try {
      const response = await getRefundDetails(orderId);
      set({
        refundData: response.data,
        // refundData: NORMAL_ORDER_DATA,
        isLoading: false
      });
    } catch (error) {
      const fallbackError = _.get(error, ['message'], 'Failed to fetch refund details');
      const errorMessage = _.get(error, ['response', 'data', 'message'], fallbackError);
      const nestedError = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);

      set({
        isError: true,
        isLoading: false,
        errorMessage: nestedError
      });
      toast.error(nestedError);
    }
  },

  // Initiate refund
  initiateRefundRequest: async (payload, toast, onSuccess) => {
    set({ isInitiating: true, isError: false });
    try {
      const response = await initiateRefund(payload);
      set({ isInitiating: false });
      toast.success("Refund initiated successfully");
      if (onSuccess) onSuccess();
    } catch (error) {
      const fallbackError = _.get(error, ['message'], 'Refund initiation failed');
      const errorMessage = _.get(error, ['response', 'data', 'message'], fallbackError);
      const nestedError = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);

      set({
        isError: true,
        isInitiating: false,
        errorMessage: nestedError
      });
      toast.error(nestedError);
    }
  },

  // Fetch subscription refund details
  fetchSubscriptionRefundDetails: async (id, toast) => {
    set({ isLoading: true, isError: false, errorMessage: "" });
    try {
      const response = await getSubscriptionRefundDetailsAPI(id);
      set({
        refundData: response.data,
        // refundData: SUBSCRIPTION_DATA,
        isLoading: false
      });
    } catch (error) {
      const fallbackError = _.get(error, ['message'], 'Failed to fetch subscription details');
      const errorMessage = _.get(error, ['response', 'data', 'message'], fallbackError);
      const nestedError = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);

      set({
        isError: true,
        isLoading: false,
        errorMessage: nestedError
      });
      toast.error(nestedError);
    }
  },

  // Initiate offline refund
  initiateOfflineRefundRequest: async (payload, toast, onSuccess) => {
    set({ isInitiating: true, isError: false });
    try {
      await initiateOfflineRefund(payload);
      set({ isInitiating: false });
      toast.success("Refund initiated successfully");
      if (onSuccess) onSuccess();
    } catch (error) {
      const fallbackError = _.get(error, ['message'], 'Refund initiation failed');
      const errorMessage = _.get(error, ['response', 'data', 'message'], fallbackError);
      const nestedError = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);

      set({
        isError: true,
        isInitiating: false,
        errorMessage: nestedError
      });
      toast.error(nestedError);
    }
  },

  // Clear state
  clearRefundState: () => {
    set({
      refundData: null,
      isError: false,
      errorMessage: "",
      isLoading: false,
      isInitiating: false
    });
  }
}));

export const useValidWarehouse = create((set) => ({
  checkValidWarehouse: {},
  validWarehouseData: [],
  fetchCheckValidWareHouse: async (id) => {
    try {
      const response = await checkValidWarehouse(id);
      set({ checkValidWarehouse: response.data });
    } catch (error) {
      console.error(error);
    }
  },
  fetchValidWarehouse: async () => {
    try {
      const response = await getValidWarehouse();
      set({ validWarehouseData: response.data });
    } catch (error) {
      console.error(error);
    }
  },
  updateWarehouse: async (payload, setToaster, fetchCustomerData, caseId) => {
    setToaster("Update Warehouse", "Updating Warehouse", "success");
    try {
      await postWarehouse(payload);
      setToaster("Update Warehouse", "Updated Warehouse", "success");
      fetchCustomerData(caseId);
    } catch (error) {
      setToaster("Update Warehouse", "Failed to Update Warehouse", "danger");
    }
  },
  markShipped: async (id, payload, setToaster) => {
    setToaster("Mark Shipped", "Marking as Shipped", "success");
    try {
      await postMarkShipped(id, payload);
      setToaster("Mark Shipped", "Marked as Shipped", "success");
    } catch (error) {
      setToaster("Mark Shipped", "Failed to Marked as Shipped", "danger");
    }
  },
  markVoidOrder: async (id) => {
    try {
      await putVoidOrder(id);
    } catch (error) {
      console.error(error);
    }
  },
}));

export const useVoidOrder = create((set) => ({
  markVoidOrder: async (id) => {
    try {
      await putVoidOrder(id);
    } catch (error) {
      console.error(error);
    }
  },
}));
export const useMarkOrderAsDelivered = create((set) => ({
  markOrderDelivered: async (id, deliveryDate) => {
    try {
      await postMarkDelivered(id, deliveryDate);
    } catch (error) {
      console.error("error", error);
    }
  },
}));

export const useRTOVoidOrder = create((set) => ({
  markRTOVoidOrder: async (orderDisplayId) => {
    try {
      await postRTOVoidOrder({ orderDisplayId });
    } catch (error) {
      console.error("error", error);
    }
  },
}));

export const useOrderTrackingInfo = create((set) => ({
  orderTrackingInfo: {},
  fetchOrderTrackingInfo: async (orderDisplayId) => {
    try {
      const response = await getOrderTRackingInfo(orderDisplayId);
      set({ orderTrackingInfo: response.data });
    } catch (error) {
      console.error("error", error);
    }
  },
}));

export const usePrescriptionCanvas = create((set) => ({
  prescriptionCanvas: false,
  setPrescriptionForm: (toggle) => {
    set({ prescriptionCanvas: toggle });
  },
}));

export const useProductCanvas = create((set) => ({
  productCanvas: false,
  bookingId: "",
  setProductCanvas: (toggle) => {
    set({ productCanvas: toggle });
  },
  setBookingId: (id) => {
    set({ bookingId: id });
  },
}));

export const useDoctorSlot = create((set) => ({
  markedSlot: false,
  markSlotLoading: false,
  error: null,
  markDoctorSlotFinished: async (
    caseId,
    payload,
    toast
  ) => {
    try {
      set({ markSlotLoading: true, error: null });
      await markSlotFinished(caseId, payload);
      set({ markedSlot: true, markSlotLoading: false });
      toast.success("Call Disposed Successfully", TOAST_MESSAGE_CSS);
      return true;
    } catch (error) {
      console.error(error);
      toast.error("There is some error", TOAST_MESSAGE_CSS);
      set({ markSlotLoading: false });
      return false;
    }
  },
  setMarkSlot: (toggle) => {
    set({ markSlot: toggle });
  },
  markPaidDoctorSlotFinished: async (
    caseId,
    payload,
    toast
  ) => {
    try {
      set({ markSlotLoading: true, error: null });
      await markPaidSlotFinished(caseId, payload);
      set({ markedSlot: true, markSlotLoading: false });
      toast.success("Call Disposed Successfully", TOAST_MESSAGE_CSS);
      return true;
    } catch (error) {
      console.error(error);
      toast.error("There is some error", TOAST_MESSAGE_CSS);
      set({ markSlotLoading: false });
      return false;
    }
  },
}));

export const useMarkORderInProgress = create((set) => ({
  orderInProgress: async (orderId, toast, reason) => {
    toast.warning(" Updating, Please wait...");
    try {
      await markOrderInProgress(orderId, reason);
      toast.success("Successfully Assign Back to operation");
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message);
    }
  },
}));

export const useMedicines = create((set) => ({
  medicines: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  medicinesData: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await getMedicines();
      set({ medicines: response.data });
    } catch (error) {
      set({ error: error?.response.data.Error });
    } finally {
      set({ isLoading: false });
    }
  },
}));
export const useDosages = create((set) => ({
  dosages: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  dosagesData: async (orderId) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getDosages(orderId);
      set({ dosages: response.data });
    } catch (error) {
      set({ error: error?.response?.data?.Error });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const prescription = create((set) => ({
  prescriptionLoading: false,
  isError: false,
  errorMessage: "",
  setPrescription: async (
    orderId,
    prescription,
    toast,
    fetchPrescriptionData,
    caseId
  ) => {
    try {
      set({ prescriptionLoading: true, error: null });
      await postPrescription(orderId, prescription);
      toast.success("Prescription Created successfully");
      await fetchPrescriptionData(caseId);
      set({ prescriptionLoading: false });
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to create prescription"
      );
    } finally {
      set({ prescriptionLoading: false });
    }
  },
}));

export const useDeletePrescrption = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  setDeletPrescription: async (
    prescriptionId,
    fetchPrescriptionData,
    caseId,
    toast
  ) => {
    try {
      set({ isLoading: true, error: null });
      await deletePrescription(prescriptionId);
      toast.success("Prescription Deleted Successfully");
      await fetchPrescriptionData(caseId);
    } catch (error) {
      // set({ error: error?.response.data.Error });
      toast.error(
        error?.response?.data?.message || "Failed to delete prescription"
      );
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useConsultDoctor = create((set) => ({
  bookedData: [],
  slotData: [],
  postSlotData: null,
  doctorData: [],
  allSlotData: [],
  pcSlotData: [],
  bookedLoading: false,
  doctorLoading: false,
  postSlotLoading: false,
  allSlotLoading: false,
  pcSlotLoading: false,
  stickyDoctorAvailable: true,
  stickyDoctorSetting: null,
  isLoading: false,
  isError: false,
  fetchOnboardingData: async (payload, toast) => {
    try {
      set({ bookedLoading: true, error: null });
      const response = await onBoardingApi(payload);
      set({ bookedData: response.data, bookedLoading: false });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      set({ error: error.message, bookedLoading: false });
    }
  },
  fetchStickyDoctorSetting: async () => {
    try {
      const response = await getSetting('STICKY_DOCTOR_ROLLOUT');
      const raw = response?.data?.value;
      const setting = typeof raw === 'string' ? JSON.parse(raw) : raw;
      set({ stickyDoctorSetting: setting || null });
    } catch {
      set({ stickyDoctorSetting: null });
    }
  },
  fetchDoctorSlotData: async (caseId, sub_category= null, language = null, stickyDoctor = true) => {
    try {
      set({ bookedLoading: true, error: null });

      const response = await getDoctorSlotApi(caseId, sub_category, language, stickyDoctor);

      // If sticky doctor requested but no slots, fallback to all doctors
      if (stickyDoctor && !response?.data?.length) {
        const fallbackResponse = await getDoctorSlotApi(caseId, sub_category, language, false);
        set({ slotData: fallbackResponse.data, bookedLoading: false, stickyDoctorAvailable: false });
        if (!fallbackResponse?.data?.length) {
          toast.warning("No slot is available");
        }
        return;
      }

      set({ slotData: response.data, bookedLoading: false, stickyDoctorAvailable: true });
      if (!response?.data?.length) {
        toast.warning("No slot is available");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      set({ error: error.message, bookedLoading: false });
    }
  },
  postDoctorSlotData: async (payload, toast, handleClose, ticketId, ticketPayload, updateAssignedData) => {
    try {
      set({ isLoading: true, error: null });
      if(payload) {
        const response = await postDoctorSlot(payload);
        set({ postSlotData: response.data, isLoading: false, isError: false });
        ticketPayload.current_assignment = response.data.assignment_id;
        toast.success("Slot booked successfully");
      }
      // Only update ticket if updateAssignedData function is provided
      // In TicketDetailsPanel's handleConfirmChanges, ticket is already updated in Step 1,
      // so updateAssignedData is not passed to avoid duplicate updates
      if (updateAssignedData && typeof updateAssignedData === 'function') {
        updateAssignedData(ticketId, ticketPayload);
      }
      handleClose();
    } catch (error) {
      console.error(error);
      toast.error(`${error?.response?.data?.message}`);
      set({ error: error.message, isLoading: false, isError: true });
    }
  },
  postDoctorSlotMedicalData: async (
    payload,
    toast,
    handleClose,
    payloadEditTicket,
    updateAssignedData,
    ticketId,
    setSelectSlot,
    selectedSlot,
    setToaster
  ) => {
    try {
      set({ isLoading: true, error: null });
      const response = await postDoctorSlot(payload);
      set({ postSlotData: response.data, isLoading: false, isError: false });
      setSelectSlot(selectedSlot);
      payloadEditTicket.current_assignment = response.data.assignment_id;
      // Only update ticket if updateAssignedData function is provided and ticketId is defined
      if (ticketId !== undefined && updateAssignedData && typeof updateAssignedData === 'function') {
        updateAssignedData(ticketId, payloadEditTicket, setToaster);
      }
      handleClose();
      toast.success("Slot booked successfully");
    } catch (error) {
      console.error(error);
      setSelectSlot(`${error?.response?.data?.message}`);
      toast.error(`${error?.response?.data?.message}`);
      handleClose();
      set({ error: error.message, isLoading: false, isError: true });
    }
  },
  fetchDoctorData: async (toast) => {
    try {
      set({ doctorLoading: true, error: null });
      const response = await allDoctor();
      set({ doctorData: response.data, doctorLoading: false });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      set({ error: error.message, doctorLoading: false });
    }
  },
  postSlotApiData: async (payload, setToaster, handleClose) => {
    try {
      set({ postSlotLoading: true, error: null });
      const response = await slotApi(payload);
      set({ postSlotData: response.data, postSlotLoading: false });
      handleClose();
      setToaster("Slot Booking", "Slot booked successfully", "success");
    } catch (error) {
      console.error(error);
      toast.error(`Slot Booking ${_.get(error, ['response' ,'data', 'message'])}`);
      handleClose();
      set({ error: error.message, postSlotLoading: false });
    }
  },
  fetchSlotData: async (caseId, sessionId, toast, isFollowUp = false, slot, type='', agentSlot='', preferredLanguage='') => {
    try {
      set({ allSlotLoading: true, error: null });
      const response = await getSlotApi(caseId, sessionId, isFollowUp, slot, type, agentSlot, preferredLanguage);
      set({ allSlotData: response.data, allSlotLoading: false });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      set({ error: error.message, allSlotLoading: false });
    }
  },
  fetchMedicalSlotData: async (caseId, sessionId, toast) => {
    try {
      set({ allSlotLoading: true, error: null });
      const response = await getMedicalSlotApi(caseId, sessionId);
      set({ allSlotData: response.data, allSlotLoading: false });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      set({ error: error.message, allSlotLoading: false });
    }
  },
  clearPCSlotData: () => {
    set({ pcSlotData: [], pcSlotLoading: false, error: null });
  },
  clearRegularSlotData: () => {
    set({ allSlotData: [], allSlotLoading: false, error: null });
  },
  fetchPCSlotData: async (caseId, sessionId, toast) => {
    try {
      set({ pcSlotLoading: true, error: null });
      const response = await getSlotApiForPC(caseId, sessionId);
      set({ pcSlotData: response.data, pcSlotLoading: false });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      set({ error: error.message, pcSlotLoading: false });
    }
  },
  postSlotDoctorApiData: async (
    payload,
    toast,
    handleClose,
    ticketObject,
    fetchMeidcalCreateTicket
  ) => {
    try {
      // set({ postSlotLoading: true, error: null });
      // const response = await slotApi(payload);
      // set({ postSlotData: response.data, postSlotLoading: false });
      // const { assignment_id } = response.data;
      const updatedTicketObject = {
        ...ticketObject,
        manual_medical_slot: true
      };
      // Ticket reports its own success/error. The picker is not reset, so the booked slot details show after success
      // and the agent can retry after a failure.
      await fetchMeidcalCreateTicket(updatedTicketObject, toast, true);
    } catch (error) {
      console.error(error);
      toast.error(`${error?.response?.data?.message}`, TOAST_MESSAGE_CSS);
      handleClose();
      set({ error: error.message, postSlotLoading: false });
    }
  },
  postSlotTicketMedicalApiData: async (payload, toast) => {
    try {
      set({ postSlotLoading: true, error: null });
      const response = await slotApi(payload);
      set({ postSlotData: response.data, postSlotLoading: false });
      toast.success("Slot booked successfully");
      return response;
    } catch (error) {
      if (error?.response.status === 409) {
        toast.error(
          "You already have a slot booked, please wait till we reach out to you."
        );
      } else {
        toast.error(`${error?.response?.data?.message}`);
      }
      set({ error: error.message, postSlotLoading: false });
      return "false";
    }
  },
}));

export const useLeadAssignOrder = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  postLeadAssignOrder: async (
    payload,
    setToaster,
    fetchCustomerData,
    caseId
  ) => {
    try {
      set({ isLoading: true, error: null });
      await assignLeadOrder(payload);
      set({ isLoading: false, error: null });
      setToaster("Assigned", "Assigned Successfully", "success");
      fetchCustomerData(caseId);
    } catch (error) {
      set({ error: error?.response.data.Error, isLoading: false });
      setToaster("Assigned", "Assigned failed", "danger");
    }
  },
}));

export const useSlotBookingStoreFeedback = create((set) => ({
  doctorFlag: false,
  doctorPrescriptionForm: (flag) => {
    set({ doctorFlag: flag });
  },
}));

export const useExpectationSettings = create((set) => ({
  expectationData: [],
  expectationLoading: false,
  isError: false,
  fetchExpectationData: async (case_id) => {
    set({ expectationLoading: true });
    try {
      const response = await getExpectation(case_id);
      set({ expectationData: response.data, expectationLoading: false });
    } catch (error) {
      set({ isError: true, expectationLoading: false });
    }
  },
}));

export const useEditPrescription = create((set) => ({
  editLoading: false,
  isError: false,
  errorMessage: "",
  editPrescription: async (
    orderId,
    prescription,
    toast,
    fetchPrescriptionData,
    caseId
  ) => {
    try {
      set({ editLoading: true, error: null });
      await putPrescription(orderId, prescription);
      toast.success("Prescription Updated Successfully");
      await fetchPrescriptionData(caseId);
      set({ editLoading: false, error: null });
    } catch (error) {
      // set({ error: error?.response.data.Error });
      toast.error(
        error?.response?.data?.message || "Failed to Update prescription"
      );
    } finally {
      set({ editLoading: false });
    }
  },
}));

export const useRootCauseData = create((set) => ({
  rootCauseData: [],
  rootCauseLoading: false,
  isError: false,
  fetchRootCauseData: async (syntheticId) => {
    set({ rootCauseLoading: true });
    try {
      const response = await rootCause(syntheticId);
      set({ rootCauseData: response.data, rootCauseLoading: false });
    } catch (error) {
      set({ isError: true, rootCauseLoading: false });
    }
  },
}));

export const useMonthKitData = create((set) => ({
  kitData: [],
  kitLoading: false,
  isError: false,
  fetchMonthKitData: async (caseId) => {
    set({ kitLoading: true });
    try {
      const response = await monthKit(caseId);
      set({ kitData: response.data, kitLoading: false });
    } catch (error) {
      set({ isError: true, kitLoading: false });
    }
  },
}));

export const useProductDetails = create((set) => ({
  productDetails: {},
  fetchProductDetails: async (variantId) => {
    try {
      const response = await api.get(`productContent/${variantId}`);
      set({ productDetails: response.data });
    } catch (error) {
      console.error("Error fetching product details:", error.message);
    }
  },
}));

export const useValidateDiscount = create((set) => ({
  disData: [],
  disCode: [],
  codeLoading: false,
  disLoading: false,
  isError: false,
  postDisData: async (payload, setOrgDisData) => {
    set({ disLoading: true });
    try {
      const response = await getDiscountCodeVal(payload);
      set({ disData: response.data, disLoading: false });
      setOrgDisData(response.data);
    } catch (error) {
      set({ isError: true, disLoading: false });
    }
  },
  getDiscountData: async () => {
    set({ codeLoading: true });
    try {
      const response = await discountCode();
      set({ disCode: response.data, codeLoading: false });
    } catch (error) {
      set({ isError: true, codeLoading: false });
    }
  },
}));

export const useRtoReattemptCategory = create((set) => ({
  rtoReattemptCategoryData: {},
  fetchRtoReattemptCategory: async (caseId, signal) => {
    try {
      const response = await getRtoReattemptCategoryData(caseId, signal);
      set({ rtoReattemptCategoryData: response.data });
    } catch (error) {
      // Don't log error if request was aborted
      if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
        return;
      }
      console.error('error in fetchRtoReattemptCategory', error);
    }
  },
}));

export const useCancelFulfillments = create((set) => ({
  updateCancelFullfiment: async (orderNumber, toast) => {
    try {
      set({ error: null });
      await cancelFullfillment(orderNumber);
      toast.success("fulfillment cancelled successfully", TOAST_MESSAGE_CSS);
      set({ error: null });
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to cancel fulfillment",
        TOAST_MESSAGE_CSS
      );
    }
  },
}));

export const useScalpImage = create((set) => ({
  deleteScalpImage: async (id, toast) => {
    try {
      set({ error: null });
      await deleteScalp(id);
      toast.success("Image Deleted Successfully", TOAST_MESSAGE_CSS);
      set({ error: null });
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to delete Image",
        TOAST_MESSAGE_CSS
      );
    }
  },
}));


export const useOldEngagementResponse = create((set) => ({
  data: {},
  isLoading: false,
  isError: false,
  fetchOldEngagementResponse: async (customer_id) => {
    set({ isLoading: true });
    try {
      const response = await getOldEngagementResponseData(customer_id);
      set({ data: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useUpdateIMage = create((set) => ({
  data: {},
  isLoading: false,
  isError: false,
  updateImageData: async (imageId, payload) => {
    set({ isLoading: true });
    try {
      const response = await imageTag(imageId, payload);
      toast.success("Image tagged with stage", TOAST_MESSAGE_CSS);
      set({ data: response.data, isLoading: false });
    } catch (error) {
      toast.error("Failed to tag image", TOAST_MESSAGE_CSS);
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useFeedbackFormStore = create((set) => ({
  data: {},
  isLoading: false,
  isError: false,
  fetchfeedbackFormFetchData: async (caseId, formName) => {
    set({ isLoading: true, isError: false });
    try {
      const response = await getFeedbackFormData(caseId, formName); 
      set((state) => ({
        ...state,
        data: { ...state.data, [formName]: response.data },
        isLoading: false,
      }));
      return response.data;
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useOfflineApptStore = create((set) => ({
  appointments: {},
  apptLoading: false,
  isBooking: false,
  isError: false,
  fetchAppointmentData: async (caseId, clinicId, isDoctorBooking, is15DaysSlotRequired) => {
    if(!caseId || !clinicId){
      toast.warn(!clinicId ? 'Please select a clinic id' : 'Case ID is missing');
      return ;
    }
    set({ apptLoading: true, isError: false });
    try {
      let response = { data: {} };
      if (isDoctorBooking) {
        response = await getClinicDoctorSlots(caseId, clinicId, is15DaysSlotRequired);
      } else {
        response = await getOfflineCoachAppointment(caseId, clinicId, is15DaysSlotRequired);
      }
      const data = markBlockedClinicSlots(response.data);
      set({ appointments: data, apptLoading: false });
      return data;
    } catch (error) {
      set({ isError: true, apptLoading: false });
      console.error('Error fetching appointment data:', error);
    }
  },
  bookOfflineAppt: async (payload, clinicId) => {
    set({ isBooking: true, isError: false });
    try {
      const response = await bookApptSlot({ ...payload, source: "crm" }, clinicId);
      set({ isBooking: false, isError: false });
      toast.success(`Appointment Booked successfully at ${moment(response.data.reminder_date).tz("Asia/Kolkata").format("D MMM h:mm A")}`, TOAST_MESSAGE_CSS);
    } catch (error) {
      set({ isError: true, isBooking: false });
      console.error('Failed to book appointment:', error);
      toast.error(`Failed to book appointment: ${error.message}`, TOAST_MESSAGE_CSS);
    }
  },
}));

export const useMoengageEventData = create((set) => ({
  eventMoengData: [],
  eventMoengLoading: false,
  isError: false,
  fetchEventMoengData: async (caseId, eventName) => {
    set({ eventMoengLoading: true });
    try {
      const response = await caseMoengageEvents(caseId, eventName);
      set({ eventMoengData: response.data, eventMoengLoading: false });
    } catch (error) {
      set({ isError: true, eventMoengLoading: false });
    }
  },
}));

export const useChatSlotData = create((set) => ({
  isLoading: false,
  isError: false,
  fetchNearestSlot: async (caseId) => {
    set({ isLoading: true });
    try {
        await booNearestSlot(caseId, { slot_time: moment().format('YYYY-MM-DD HH:mm:ss'), level: 1 });
        toast.success('Slot Booked Successfully', TOAST_MESSAGE_CSS);
      } catch (error) {
      console.error(error);
      set({ isError: true, isLoading: false });
      toast.error('failed to book Slot', TOAST_MESSAGE_CSS);
    }
  },
}));

export const useOfflineCustomerData = create((set) => ({
  offlineCustomerInfo: {},
  fetchOfflineCustomerInfo: async(caseId) => {
    const response = await getOfflineCustomerInfo(caseId);
    set({ offlineCustomerInfo: response.data });
  }
}))

export const useAiSummary = create((set) => ({
  summaryData: {},
  summaryLoading: false,
  isError: false,
  fetchSummaryData: async (caseId) => {
    set({ summaryLoading: true });
    try {
      const response = await getAiSummary(caseId);
      set({ summaryData: response.data, summaryLoading: false });
    } catch (error) {
      set({ isError: true, summaryLoading: false });
    }
  },
}));

export const useNearestClinics = create((set) => ({
  clinics: [],
  searchLocation: null,
  totalCount: 0,
  isLoading: false,
  isError: false,
  errorMessage: "",

  fetchNearestClinics: async (params) => {
    set({ isLoading: true, isError: false, errorMessage: "" });
    try {
      const response = await getNearestClinics(params);
      set({
        clinics: response.data.clinics || [],
        searchLocation: response.data.search_location || null,
        totalCount: response.data.count || 0,
        isLoading: false
      });
      return response.data;
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error.response?.data?.message || "Failed to fetch nearest clinics",
        clinics: [],
        totalCount: 0
      });
      throw error;
    }
  },

  resetClinics: () => {
    set({
      clinics: [],
      searchLocation: null,
      totalCount: 0,
      isError: false,
      errorMessage: ""
    });
  }
}));

export const useHairCoachQuestions = create((set) => ({
  questions: [],
  isLoading: false,
  isError: false,
  errorMessage: "",

  fetchHairCoachQuestions: async () => {
    set({ isLoading: true, isError: false, errorMessage: "" });
    try {
      // Determine setting key based on logged-in user's level
      const userLevel = secureLocalStorage.getItem("level");
      const settingKey = userLevel === 2
        ? 'HAIR_COACH_QUESTIONS_PC'
        : 'HAIR_COACH_QUESTIONS_PRO_BEG';

      // Fetch from Settings API based on level
      const response = await getSetting(settingKey);

      // Handle different possible response structures
      let questionsData;

      if (response?.data) {
        // If data.value exists and is a string (JSON), parse it
        if (typeof response.data.value === 'string') {
          try {
            questionsData = JSON.parse(response.data.value);
          } catch (parseError) {
            throw new Error('Invalid JSON format in settings');
          }
        }
        // If data.value is already an object/array
        else if (response.data.value !== undefined) {
          questionsData = response.data.value;
        }
        else {
          questionsData = [];
        }
      } else {
        questionsData = [];
      }

      // Validate that we have an array before setting state
      if (!Array.isArray(questionsData)) {
        throw new Error('Expected questions to be an array');
      }

      set({
        questions: questionsData,
        isLoading: false
      });
    } catch (error) {
      const errorMsg = error?.response?.data?.message || error?.message || "Failed to fetch hair coach questions";

      set({
        isError: true,
        errorMessage: errorMsg,
        questions: [],
        isLoading: false
      });
      toast.error(errorMsg, TOAST_MESSAGE_CSS);
    }
  },

  resetHairCoachQuestions: () => {
    set({
      questions: [],
      isLoading: false,
      isError: false,
      errorMessage: "",
    });
  }
}));

export const useNpsScore = create((set) => ({
  npsData: null,
  isLoading: false,
  isError: false,
  fetchNpsData: async (case_id) => {
    set({ isLoading: true, isError: false });
    try {
      const response = await getNpsCaseData(case_id);
      set({ npsData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false, npsData: null });
    }
  },
  clearNpsData: () => set({ npsData: null, isLoading: false, isError: false }),
}));

export const useRateLimit = create((set, get) => ({
  isRateLimited: false,
  isLoading: false,
  isRemoving: false,
  hasFetched: false,

  fetchRateLimitStatus: async (phone) => {
    if (!phone) return;
    try {
      set({ isLoading: true });
      const response = await getRateLimitStatus(phone);
      set({
        isRateLimited: !!_.get(response, ['data', 'isRateLimited'], false),
        isLoading: false,
        hasFetched: true,
      });
    } catch (error) {
      set({ isRateLimited: false, isLoading: false, hasFetched: true });
    }
  },

  removeRateLimit: async (phone) => {
    if (!phone) return;
    try {
      set({ isRemoving: true });
      await removeRateLimitApi(phone);
      toast.success("Rate limit removed", TOAST_MESSAGE_CSS);
      await get().fetchRateLimitStatus(phone);
      set({ isRemoving: false });
    } catch (error) {
      const fallbackError = _.get(error, ['message'], 'Failed to remove rate limit');
      const errorMessage = _.get(error, ['response', 'data', 'message'], fallbackError);
      const nestedError = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);
      toast.error(nestedError, TOAST_MESSAGE_CSS);
      set({ isRemoving: false });
    }
  },

  clearRateLimit: () => set({
    isRateLimited: false,
    isLoading: false,
    isRemoving: false,
    hasFetched: false,
  }),
}));
